/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostSpendByDimensionWidgetConfiguration extends models.BaseDimensionWidgetConfiguration {
    constructor() {
        super();
        this.setDiscriminator("CostSpendByDimensionWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostSpendByDimensionWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostSpendByDimensionWidgetConfiguration>): CostSpendByDimensionWidgetConfiguration {
        let obj = Object.assign(new CostSpendByDimensionWidgetConfiguration(), model);
        CostSpendByDimensionWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostSpendByDimensionWidgetConfiguration>): CostSpendByDimensionWidgetConfiguration {
        if (!model) return null;
        return CostSpendByDimensionWidgetConfiguration.newInstance(<CostSpendByDimensionWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostSpendByDimensionWidgetConfiguration) {
        if (!obj) return;

        models.CostSpendByDimensionWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostSpendByDimensionWidgetConfiguration): boolean {
        if (models.BaseDimensionWidgetConfiguration.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostSpendByDimensionWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    selectedAccountId: string;

}
